import styled from "styled-components";

export const IdeaKpiColumn = styled.div`
    display: flex;
    justify-content: flex-end;
    text-transform: none;
    font-size: 11px;
    padding-right: 8px;
`;

export const IdeaKpiCell = styled(IdeaKpiColumn)`
    font-size: 12px;
`;